import Layout from '@/views/layout'
const workRouter = [{
  path: '/work',
  component: Layout,
  children: [{
    path: 'index',
    name: 'WorkForecast',
    meta: {title: '预测', module: 'work', icon: 'forecast'},
    component: () => import(/* webpackChunkName: "work" */ '@/views/work/Forecast')
  }]
}, {
  path: '/work/info',
  component: Layout,
  hidden: true,
  children: [{
    path: ':id',
    name: 'WorkInfo',
    meta: {title: '预测结果', module: 'work'},
    component: () => import(/* webpackChunkName: "work_info" */ '@/views/work/Info')
  }]
}, {
  path: '/work/fee',
  component: Layout,
  children: [{
    path: 'index',
    name: 'WorkFee',
    meta: {title: '计费', module: 'work', icon: 'fee'},
    component: () => import(/* webpackChunkName: "work_fee" */ '@/views/work/Fee')
  }]
}]

export default workRouter
